import { HeadingNode, QuoteNode } from '@lexical/rich-text';
import { ListItemNode, ListNode } from '@lexical/list';
import { LinkNode, AutoLinkNode } from '@lexical/link';
import { CodeHighlightNode, CodeNode } from '@lexical/code';
import { RedactedNode } from '../nodes/RedactedNode';
import { editorTheme } from '../constants/themes';

export const createEditorConfig = () => ({
  namespace: 'RichTextEditor',
  nodes: [
    HeadingNode,
    ListNode,
    ListItemNode,
    QuoteNode,
    CodeNode,
    CodeHighlightNode,
    AutoLinkNode,
    LinkNode,
    RedactedNode,
  ],
  onError: (error) => {
    console.error(error);
  },
  theme: editorTheme,
});
